var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.me ? _c('div', {
    staticClass: "user-login-info"
  }, [_c('div', {
    staticClass: "user-login-info__wrap"
  }, [_c('div', {
    staticClass: "user-login-info__left"
  }, [_c('span', {
    staticClass: "font-size-16 font-size-md-18 font-size-lg-22"
  }, [_c('b', [_vm._v(_vm._s(_vm.me.name))]), _vm._v("님"), _c('br', {
    staticClass: "d-lg-none"
  }), _vm._v(" 반갑습니다.")])]), _c('div', {
    staticClass: "user-login-info__right font-size-14 font-size-md-18 text-right"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "justify-md": "end"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('span', [_vm._v("캐시잔액 : "), _c('b', {
    staticClass: "font-size-18 font-size-md-22 secondary--text"
  }, [_vm._v(_vm._s(_vm.me.cash.format()))]), _vm._v("원")])]), _c('v-col', {
    staticClass: "d-none d-md-block",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-divider', {
    staticClass: "mx-28px",
    staticStyle: {
      "max-height": "14px",
      "min-height": "14px",
      "border-color": "#999"
    },
    attrs: {
      "vertical": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('span', [_vm._v("포인트 잔액 : "), _c('b', {
    staticClass: "font-size-18 font-size-md-22 secondary--text"
  }, [_vm._v(_vm._s(_vm.me.point.format()))]), _vm._v("원")])])], 1)], 1)])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }